export const UPDATE_RENT_SOURCE_DATA = 'releaseRentalHousing/UPDATE_RENT_SOURCE_DATA';
export const EMPTY_RENT_SOURCE_DATA = 'releaseRentalHousing/EMPTY_RENT_SOURCE_DATA';
const initialState = {
  rentSourceData: {
    location:"1",
    textPrefix: '',
    district: "",
    subwayLine:"",
    subwayStation:"",
    subwayStationArr:[],
    rent: '',
    area: '',
    houseType: '',
    warm_type: '',
    layer_levels: '',
    house_orientations: '',
    decoration_levels: '',
    sort: '',
    rentMoneyStart: '',              //租金区间开始
    rentMoneyEnd: '',                //租金区间开始
    areaStart: '',                   //面积区间开始
    areaEnd: '',                     //面积区间开始
    houseData: [],
    sortSc: 'desc',   // 默认倒序
    numberShow: false,
    equipments: '',
    pay_type_request_mortgage_month: '',
    frameBedroomNum:'',
    frameOrientation:'',
    rentType:'',
    brand:''

  },
};
const rentSourceDataReducer = (rentSourceData = 0, action)=> {
  switch (action.type) {
    case UPDATE_RENT_SOURCE_DATA:
      return {
        ...rentSourceData,
        [action.subType]: action.data
      }
    case EMPTY_RENT_SOURCE_DATA:
      let obj =  {
        location:"1",
        subwayLine:"",
        subwayStation:"",
        subwayStationArr:[],
        district:"",
        textPrefix: '',
        rent: '',
        area: '',
        houseType: '',
        warm_type: '',
        layer_levels: '',
        house_orientations: '',
        decoration_levels: '',
        sort: '',
        rentMoneyStart: '',              //租金区间开始
        rentMoneyEnd: '',                //租金区间开始
        areaStart: '',                   //面积区间开始
        areaEnd: '',                     //面积区间开始
        houseData: [],
        sortSc: 'desc',   // 默认倒序
        numberShow: false,
        equipments: '',
        pay_type_request_mortgage_month: '',
        frameBedroomNum:'',
        frameOrientation:'',
        rentType:'',
        brand:''
    }
      return obj

    default:
      return rentSourceData
  }
}
export default (state = initialState, action) => {
  return {
    rentSourceData: rentSourceDataReducer(state.rentSourceData, action)
  };
}
export const dispatch_func = {
  update_rentSourceData: (data, type) => {
    return dispatch => {
      dispatch({
        type: UPDATE_RENT_SOURCE_DATA,
        data: data,
        subType: type
      });
    }
  },
  empty_rentSourceData: () => {
    return dispatch => {
      dispatch({
        type: EMPTY_RENT_SOURCE_DATA,
      });
    }
  },
};


// WEBPACK FOOTER //
// ./src/modules/rentHouseSource.js